/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { ICrawlingURLData, ICrawlingURLState, IUrlData } from "types/models/crawling-url";
import { RootState } from "types/reducer";

const initialState: ICrawlingURLState = {
  crawling_data: {
    current_page: 1,
    limit_per_page: 10,
    list_crawling_url: [],
    total_pages: 1,
    frequency_crawling: ''
  },
  frequency: [],
  detail_url: [],
  category: [],
};

const CrawlingURLSlice = createSlice({
  name: "crawling-url",
  initialState,
  reducers: {
    updateFrequency(state, action: PayloadAction<string>) {

    },
    updateFrequencySuccess(state, action: PayloadAction<string>) {
      state.crawling_data = {
        ...state.crawling_data,
        frequency_crawling: action.payload
      }
    },
    addNewURL(state, action: PayloadAction<any>) {},
    addNewURLSuccess(state, action: PayloadAction<any>) {
      state.crawling_data = action.payload;
    },
    updateURL(state, action: PayloadAction<any>) {},
    updateURLSuccess(state, action: PayloadAction<any>) {
      state.crawling_data = {
        ...action.payload
      }
    },
    deleteURL(state, action: PayloadAction<any>) {},
    deleteURLSuccess(state, action: PayloadAction<ICrawlingURLData>) {
      state.crawling_data = {
        ...action.payload
      }
    },
    fetchCrawlingURL(state, action: PayloadAction<any>){},
    fetchCrawlingURLSuccess(
      state: Draft<ICrawlingURLState>,
      action: PayloadAction<ICrawlingURLData>
    ){
      state.crawling_data = {
        ...action.payload
      }
    },
    fetchDetailCrawlingURL(state, action: PayloadAction<any>){},
    fetchDetailCrawlingURLSuccess(
      state: Draft<ICrawlingURLState>,
      action: PayloadAction<ICrawlingURLData>
    ){
      state.crawling_data = {
        ...action.payload
      }
    },
    fetchFrequency(){},
    fetchFrequencySuccess(
      state: Draft<ICrawlingURLState>,
      action: PayloadAction<any>
    ){
      state.frequency = action.payload;
    },
    fetchCategory(){},
    fetchCategorySuccess(
      state: Draft<ICrawlingURLState>,
      action: PayloadAction<any>
    ){
      state.category = action.payload;
    },
    fetchDetailURL(state, action: PayloadAction<any>){},
    fetchDetailURLSuccess(
      state: Draft<ICrawlingURLState>,
      action: PayloadAction<any>
    ){
      state.detail_url = action.payload;
    },
    setParamsCrawling(state, action: PayloadAction<any>){
      state.crawling_data = {
        ...state.crawling_data,
        current_page: action.payload.current,
        limit_per_page: action.payload.pageSize
      }
    },
    clearDetailURL(state){
      state.detail_url = []
    },
    deleteSummary(state, action: PayloadAction<any>) {},
    deleteSummarySuccess(state, action: PayloadAction<any>) {
      state.detail_url = action.payload.map((detail: any, idx: number) => {
        return {
          ...detail,
          index: idx + 1
        }
      });
    },
  }
});

// Actions
export const updateFrequency = CrawlingURLSlice.actions.updateFrequency;
export const updateFrequencySuccess = CrawlingURLSlice.actions.updateFrequencySuccess;
export const fetchCrawlingURL = CrawlingURLSlice.actions.fetchCrawlingURL;
export const fetchCrawlingURLSuccess = CrawlingURLSlice.actions.fetchCrawlingURLSuccess;
export const addNewURL = CrawlingURLSlice.actions.addNewURL;
export const addNewURLSuccess = CrawlingURLSlice.actions.addNewURLSuccess;
export const updateURL = CrawlingURLSlice.actions.updateURL;
export const updateURLSuccess = CrawlingURLSlice.actions.updateURLSuccess;
export const deleteURL = CrawlingURLSlice.actions.deleteURL;
export const deleteURLSuccess = CrawlingURLSlice.actions.deleteURLSuccess;
export const fetchDetailCrawlingURL = CrawlingURLSlice.actions.fetchDetailCrawlingURL;
export const fetchDetailCrawlingURLSuccess = CrawlingURLSlice.actions.fetchDetailCrawlingURLSuccess;
export const fetchFrequency = CrawlingURLSlice.actions.fetchFrequency;
export const fetchFrequencySuccess = CrawlingURLSlice.actions.fetchFrequencySuccess;
export const fetchCategory = CrawlingURLSlice.actions.fetchCategory;
export const fetchCategorySuccess = CrawlingURLSlice.actions.fetchCategorySuccess;
export const fetchDetailURL = CrawlingURLSlice.actions.fetchDetailURL;
export const fetchDetailURLSuccess = CrawlingURLSlice.actions.fetchDetailURLSuccess;
export const setParamsCrawling = CrawlingURLSlice.actions.setParamsCrawling;
export const clearDetailURL = CrawlingURLSlice.actions.clearDetailURL;
export const deleteSummary = CrawlingURLSlice.actions.deleteSummary;
export const deleteSummarySuccess = CrawlingURLSlice.actions.deleteSummarySuccess;

// Selectors
export const getCrawlingData = (state: RootState) => state.crawling_url.crawling_data;
export const getFrequencyData = (state: RootState) => state.crawling_url.frequency;
export const getDetailURLData = (state: RootState) => state.crawling_url.detail_url;
export const getCategoryData = (state: RootState) => state.crawling_url.category;

// Reducer
const CrawlingURLReducer = CrawlingURLSlice.reducer;
export default CrawlingURLReducer;
